// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"RL-z","carouselContainer":"SL-z"};